<template>
  <Body class="page-view page-review-view" />

  <!-- post header -->
  <section class="section post-header">
    <div class="wrap">
      <h1 class="post-title">
        {{ news?.title }}
      </h1>
      <div class="post-info">
        <div class="detail">
          <div v-if="news?.createdAt" class="date">
            {{ formatIntlDate(new Date(news.createdAt), locale) }}
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- photo slide (이미지가 있으면 스와이프, 없으면 썸네일 한 장) -->
  <section v-if="news && (news.images.length > 0 || news.thumbnailUrl)" class="section photo-slide">
    <div class="wrap">
      <ClientOnly v-if="news.images.length > 0">
        <Swiper
          :modules="[Pagination, Autoplay]"
          :slides-per-view="1"
          :space-between="8"
          :autoplay="false"
          :auto-height="true"
          :pagination="{ el: '.photo-slide .wrap .dots', clickable: true }"
        >
          <SwiperSlide v-for="image in news.images" :key="image.docFileId">
            <div class="item">
              <img :src="image.url" alt="">
            </div>
          </SwiperSlide>
        </Swiper>
        <div v-if="news.images.length > 1" class="dots" />
      </ClientOnly>
      <div v-else class="item">
        <img :src="news.thumbnailUrl!" alt="">
      </div>
    </div>
  </section>

  <!-- post contents -->
  <div class="section post-contents">
    <div class="wrap">
      <div class="contents-container" v-html="news?.contents" />
    </div>
  </div>

  <!-- btns -->
  <div class="section">
    <div class="wrap">
      <div class="btns">
        <a class="btn" @click="$router.back()">{{ $t('뒤로가기') }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Autoplay, Pagination } from 'swiper/modules'
// Swiper Slide
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'

interface NewsDetail {
  id: number
  thumbnailUrl: string | null
  title: string
  contents: string
  createdAt: string
  images: { docFileId: number, url: string }[]
}

const { $t } = useNuxtApp()
const { locale } = useI18n()
const route = useRoute()

const { data: news } = await useFetch<NewsDetail>(`/api/news/${route.params.id}`, {
  method: 'GET',
  query: { languageGbSn: locale.value },
})

if (!news.value) {
  throw createError({ statusCode: 404, statusMessage: 'Not Found' })
}

useHead({
  title: `${news.value.title} - ${$t('어머니사랑과평화의날캠페인')}`,
  link: [
    { rel: 'stylesheet', href: `/css/review.css?${useBuildTime()}` },
    { rel: 'stylesheet', href: 'https://pic.watv.org/watveditor/watvEditor@next.css' },
  ],
})

// 조회수 증가 — 하루 1회(후기와 동일하게 쿠키로 중복 방지), 화면에는 표시하지 않음
onMounted(async () => {
  const tomorrow = new Date()
  tomorrow.setDate(new Date().getDate() + 1)
  const viewCookie = useCookie<number[]>('HMLNewsViewIds', { expires: tomorrow, default: () => [] })
  const id = Number(route.params.id)
  if (viewCookie.value.includes(id))
    return

  viewCookie.value = [...viewCookie.value, id]
  await $fetch(`/api/news/${id}/view`, { method: 'PUT' }).catch(() => {})
})
</script>

<style scoped>
.photo-slide .item{display:flex; justify-content:center}
.photo-slide .item img{max-width:100%; height:auto}
</style>
